module.exports = __webpack_public_path__ + "static/media/blue-drop-upsidedown.91af8a86.png";